import { ConfigProvider, Modal } from "antd";
import { ConfigStepId, ConfigStepType } from "../../utils/configuration";
import Step from "../Step";
import { useSelector } from "react-redux";
import { RootState } from "../../configureStore";
import { IInstitution } from "../../redux/reducer/institution";
import { useMemo } from "react";

interface PreviewModalParams {
    id: ConfigStepId | null;
    onClose: () => void;
}

const PreviewModal = ({
    id,
    onClose,
}: PreviewModalParams) => {
    const institution = useSelector<RootState, IInstitution | undefined>(({ institution }) => institution.testInstitution);
    const step = useMemo<ConfigStepType | undefined>(() => institution?.services.find((st) => st.id === id), [institution, id]);

    return (
        <Modal
            open={Boolean(id?.length)}
            width='100%'
            onCancel={onClose}
            styles={{
                body: { height: '70vh' },
            }}
        >
            <ConfigProvider theme={institution?.customization.configuration}>
                {step && <Step step={step} onContinue={() => { }} />}
            </ConfigProvider>
        </Modal>
    );
};

export default PreviewModal;
